import { render, staticRenderFns } from "./CropManagement.vue?vue&type=template&id=a65c67b8&scoped=true&lang=html&"
import script from "./CropManagement.vue?vue&type=script&lang=js&"
export * from "./CropManagement.vue?vue&type=script&lang=js&"
import style0 from "./CropManagement.vue?vue&type=style&index=0&id=a65c67b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65c67b8",
  null
  
)

export default component.exports